import { Box } from "@mui/material";
import { forwardRef, Ref, useEffect, useState } from "react";
import Chat, { IResponseAnswer } from "../../../../components/Chat";
import { AnswersType } from "../../../../components/Chat/Answer";
import { IMessage } from "../../../../components/Chat/Message";
import ContentAdmin from "../../../../components/contentAdmin";
import useMission from "../../hooks/useMission";

export type IYouCanChallengeYourBeliefsProps = Record<string, any>;

function YouCanChallengeYourBeliefs({ ...props }: IYouCanChallengeYourBeliefsProps, ref: Ref<HTMLDivElement>)
{
	const missionContext = useMission();

	const [ messages, setMessages ] = useState<IMessage[]>(
		[ {
			type: "from",
			message: <ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_message_1" defaultValue="We all have limiting beliefs, whether they were created by us, people around us, or society." isDescription />
		} ]
	);
	const [ answers, setAnswers ] = useState<AnswersType | null>(
		{
			type: "select",
			items: [

				<ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_answer_1" defaultValue="Seems so…" position="top" />
			]
		}
	);
	const [ chatStep, setChatStep ] = useState<number>(1);

	// Utils
	function addMessage(type: IMessage[ "type" ], message: IMessage[ "message" ])
	{
		setMessages((prevState) => (
			[ ...prevState, { type, message } ]
		));
	}

	// Effects
	useEffect(() =>
	{
		switch (chatStep)
		{
			case 2: {
				addMessage(
					"from",
					<ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_message_2" defaultValue="It doesn’t matter if your belief is true or not. What matters is whether it’s empowering or disempowering." isDescription />
				);
				setAnswers({
					type: "select",
					items: [
						<ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_answer_2" defaultValue="Interesting" position="top" />
					]
				});
				break;
			}

			case 3: {
				addMessage(
					"from",
					<ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_message_3" defaultValue="How about we question your limiting beliefs and rewrite them with new, empowering ones?" isDescription />

				);
				setAnswers({
					type: "select",
					items: [
						<ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_answer_3" defaultValue="Let’s do it!" position="top" />
					]
				});
				break;
			}

			case 4: { setChatStep((prevStep) => prevStep + 1); setTimeout(() => missionContext.nextStep(), 1000); }
		}
	}, [ chatStep, missionContext ]);

	// Handles
	function onResponseAnswer({ message }: IResponseAnswer)
	{
		addMessage("to", message);
		setAnswers(null);
		setChatStep((prevStep) => prevStep + 1);
	}

	return (
		<Box ref={ref} {...props} className="mission-main main" component="main">
			<Box className="main__content" sx={{ alignItems: "center" }}>
				<Chat
					title={<ContentAdmin keyContent="contentMissionSeven" keyText="YouCanChallengeYourBeliefs_chat_title" defaultValue="You can challenge your beliefs" />}
					onResponseAnswer={onResponseAnswer}
					messages={messages}
					answers={answers}
				/>
			</Box>
		</Box>
	);
}

export default forwardRef(YouCanChallengeYourBeliefs);
